<template>
    <v-app class="bg_main">
        <Navbar></Navbar>
        <v-content v-scroll="on_scroll">

            <v-container grid-list-md class="mx-1 my-1" fluid>
                <transition name="slide-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </v-container>

        </v-content>
        <v-footer height="auto" color="bg_navbar">
            <v-card class="flex" flat tile>
                <v-card-title class="bg_navbar">
                    <a @click="$router.push('/policy')"
                       class="text-xs-center caption mx-3">
                        <v-icon small class="primary--text">security</v-icon>
                        Политика конфиденциальности
                    </a>
                    <ContactForm></ContactForm>
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn
                                v-for="social in socials"
                                :key="social.id" :to="social.href"
                                class="mx-3 secondary--text"
                                icon
                        >
                            <simple-svg style="margin-top: 5px;"
                                        :filepath="social.icon"
                                        fill="#37474F"
                                        width="24px" height="24px"></simple-svg>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-actions class="justify-center secondary bg_navbar--text">
                    <span>&copy;2019 — <strong>ООО "СДТ"</strong></span>
                </v-card-actions>
            </v-card>
        </v-footer>
        <div class="hidden-sm-and-down">
            <v-fab-transition>
                <v-btn fixed dark fab
                       bottom right color="primary"
                       v-show="btn_to_top"
                       @click="scroll_to_top"
                >
                    <v-icon>keyboard_arrow_up</v-icon>
                </v-btn>
            </v-fab-transition>
        </div>
        <div class="hidden-md-and-up">
            <v-fab-transition>
                <v-btn fixed dark fab small
                       bottom right color="primary"
                       v-show="btn_to_top"
                       @click="scroll_to_top"
                >
                    <v-icon>keyboard_arrow_up</v-icon>
                </v-btn>
            </v-fab-transition>
        </div>
    </v-app>
</template>

<script>
    import Navbar from '@/components/Navbar'
    import ContactForm from '@/components/ContactForm'

    export default {
        name: 'App',
        data() {
            return {
                // to-top
                btn_to_top: false,
                socials: [
                    {id: 1, icon: '/content/icons/logo-vk.svg', href: ''},
                    {id: 2, icon: '/content/icons/logo-facebook.svg', href: ''},
                    {id: 3, icon: '/content/icons/logo-twitter.svg', href: ''},
                    {id: 4, icon: '/content/icons/logo-instagram.svg', href: ''},
                ],
            }
        },
        components: {
            Navbar,
            ContactForm,
        },
        created() {
            this.$store.dispatch('logged_state_init', true);
        },
        methods: {
            // Offset scroll
            on_scroll(e) {
                this.btn_to_top = e.target.scrollingElement.scrollTop > 0;
            },
            scroll_to_top() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
        },
    }
</script>

<style>
    .btn-mini {
        min-width: 10px;
        width: 36px;
    }
    .mob-price-total {
        position: relative;
        bottom: -8px;
        left: -10px;
    }
     .table-container {
        display: inline-block;
        width: 100%;
    }
    table.v-table thead td:not(:nth-child(1)),
    table.v-table tbody td:not(:nth-child(1)),
    table.v-table thead th:not(:nth-child(1)),
    table.v-table tbody th:not(:nth-child(1)),
    table.v-table thead td:first-child,
    table.v-table tbody td:first-child,
    table.v-table thead th:first-child,
    table.v-table tbody th:first-child {
        padding: 0 10px;
    }
    .mob-s-item-title {
        padding-bottom: 5px;
        padding-top: 5px;
    }
    .toc-ul {
        list-style-type: disc;
    }
    .toc-ul ul{
        list-style-type: circle;
    }
    .toc-ul a{
        color: #B71C1C;
    }
    code:before {
        content: none;
    }
    .pointer-element {
        cursor: pointer;
    }
    /* TRANSITION: FADE */
    .el-fade-enter-active, .el-fade-leave-active {
        transition: opacity .5s;
    }
    .el-fade-enter, .el-fade-leave-to {
        opacity: 0;
    }
    /* Transition: SLIDE-FADE */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    {
        transform: translateX(50px);
        opacity: 0;
    }
    /* TRANSITION: LIST-FADE */
    .list-fade-enter-active {
        transition: all .3s ease;
    }
    .list-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .list-fade-enter, .list-fade-leave-to
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
